import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: { userId: "", userDetails: {}, userName:"", location: "" },
  reducers: {
    setUserId: (state,action) => {
      state.userId = action.payload
    },
    setUserName: (state,action) => {
      state.userName = action.payload
    },
    setUserDetails: (state,action) => {
      state.userDetails = action.payload
    },
    updateLocation:(state, action) =>{
      state.location = action.payload
    }
  },
});

export const { setUserId, setUserName, setUserDetails, updateLocation } = userSlice.actions;
export default userSlice.reducer;
